import React, { Component } from "react";

import edit from "../images/edit.svg";
import Delete from "../images/deletewhite.svg";
import disable from "../images/disable.svg";
import enable from "../images/enable.svg";
import CustomButton from "./CustomButton";
import Tick from "../images/tick.svg";
import Cancel from "../images/cancel.svg";
import { Form } from "react-bootstrap";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import warning from "../images/warning.png";

import Tooltip from "@mui/material/Tooltip";
import {
  BaseUrl,
  Authorization,
  WebAppUrl,
  LogoutFunction,
} from "../static.js";

export default class QRObject extends Component {
  constructor(props) {
    super(props);

    let edit = false;
    if (this.props.editMode) edit = true;
    this.state = {
      ActionsOpen: false,
      editMode: edit,
      nameValue: "",
      saveLoading: false,
      ModalShow: false,
      deleteLoading: false,
    };

    this.ActionMainButton = React.createRef();
    this.NameInput = React.createRef();
    this.textHandleChange = this.textHandleChange.bind(this);
    this.saveEditClick = this.saveEditClick.bind(this);
    this.createUpdateStation = this.createUpdateStation.bind(this);
  }

  componentDidMount() {
    window.addEventListener("click", (e) => {
      try {
        if (
          this.ActionMainButton !== undefined &&
          this.ActionMainButton !== null &&
          this.ActionMainButton.current !== undefined &&
          this.ActionMainButton.current !== null &&
          !this.ActionMainButton.current.contains(e.target)
        ) {
          this.setState({ ActionsOpen: false });
        }
      } catch (error) {}
    });

    if (this.state.editMode) this.NameInput.current.focus();

    // ReactTooltip.rebuild();
  }

  // componentDidUpdate(prvProps){
  //     if (prvProps.editMode!=)
  // }

  showQRClick() {
    window.open(
      "https://api.qrserver.com/v1/create-qr-code/?color=77-77-77&bgcolor=231-228-223&size=200x200&data=" +
        WebAppUrl +
        this.props.businessCode +
        "/" +
        this.props.id
    );
  }

  copyURLClick() {
    copy(WebAppUrl + this.props.businessCode + "/" + this.props.id);
    toast.success("آدرس کپی شد", {
      position: toast.POSITION.BOTTOM_RIGHT,
      hideProgressBar: true,
      autoClose: 6000,
      toastClassName: "toast",
    });
  }

  onActionsMainButtonClick() {
    this.setState({ ActionsOpen: !this.state.ActionsOpen });
  }

  onEdit() {
    console.log("onedit");
    this.setState(
      {
        editMode: true,
        nameValue: this.props.title,
        ActionsOpen: false,
      },
      () => {
        this.NameInput.current.focus();
      }
    );
  }

  onDelete() {
    this.setState({ ModalShow: true });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  itemDeleteConfirm() {
    let data = {
      stationId: this.props.id,
      businessId: this.props.businessId,
      businessCode: this.props.businessCode,
    };

    data = Object.assign(data, Authorization());

    this.setState({ deleteLoading: true });

    fetch(BaseUrl + "deleteStation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status !== 200) {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        } else {
          this.props.onSaveStation(result.result, null);
        }

        this.setState({ deleteLoading: false, ModalShow: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ deleteLoading: false });
      });
  }

  onDisable() {
    let enable = 1;
    if (this.props.isEnable === 1) enable = 0;
    let data = {
      id: this.props.id,
      businessId: this.props.businessId,
      businessCode: this.props.businessCode,
      isEnable: enable,
      name: this.props.title,
      orderStationType: this.props.orderStationType,
    };

    data = Object.assign(data, Authorization());

    console.log(data);

    fetch(BaseUrl + "updateStation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          if (this.props.editMode) {
            this.props.onSaveStation(result.result, null);
          } else {
            this.setState({ editMode: false });
            this.props.onSaveStation(result.result, null);
          }
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  cancelEditClick() {
    if (this.props.editMode) {
      this.props.onCancelStation();
    } else {
      this.setState({ editMode: false });
    }
  }

  createUpdateStation() {
    let api = "";
    let data;
    if (this.props.editMode) {
      api = "createNewStation";
      data = {
        businessId: this.props.businessId,
        isEnable: 1,
        name: this.state.nameValue,
        orderStationType: this.props.orderStationType,
      };
    } else {
      api = "updateStation";
      data = {
        id: this.props.id,
        businessId: this.props.businessId,
        isEnable: this.props.isEnable,
        name: this.state.nameValue,
        orderStationType: this.props.orderStationType,
      };
    }

    data = Object.assign(data, Authorization());
    data = Object.assign(data, { businessCode: this.props.businessCode });

    console.log(data);

    this.setState({ saveLoading: true });

    fetch(BaseUrl + "" + api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          if (this.props.editMode) {
            this.setState({ saveLoading: false }, () => {});
            this.props.onSaveStation(result.result, result.newItemId);
          } else {
            this.setState({ saveLoading: false }, () => {
              this.setState({ editMode: false });
              this.props.onSaveStation(result.result, null);
            });
          }
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState({ saveLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  saveEditClick() {
    this.createUpdateStation();
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.saveEditClick();
    }
  }

  render() {
    if (!this.state.editMode) {
      return (
        <div className="qrObjectContainer">
          <div
            className="qrObjectItem"
            style={{ opacity: this.props.isEnable === 1 ? "1" : "0.6" }}
          >
            <img
              src={this.props.typeImg}
              alt=""
              style={{ height: "45%", objectFit: "contain" }}
            />
            <div className="qrObjectTitle">{this.props.title}</div>
            <div className="qrObjectCopyContainer">
              <div style={{ width: "49%" }}>
                <CustomButton
                  title="نمایش"
                  minHeight="30px"
                  img={null}
                  backColor="var(--black1)"
                  onClick={this.showQRClick.bind(this)}
                />
              </div>
              <div style={{ width: "49%" }}>
                <CustomButton
                  title="کپی"
                  minHeight="30px"
                  img={null}
                  backColor="var(--black1)"
                  onClick={this.copyURLClick.bind(this)}
                />
              </div>
            </div>
          </div>
          <div
            className="qrObjectActionMainButton"
            ref={this.ActionMainButton}
            onClick={this.onActionsMainButtonClick.bind(this)}
          >
            <img
              src={edit}
              alt=""
              style={{ height: "65%", width: "65%", objectFit: "contain" }}
            />
          </div>

          {this.props.OPWarning && (
            <div
              className="qrObjectActionMainButton"
              style={{
                left: "unset",
                right: "5px",
                backgroundColor: "unset",
              }}
            >
              <Tooltip title="این ایستگاه در هیچ یک از گام‌های روال سفارش به کار نرفته است">
                <img
                  src={warning}
                  alt=""
                  style={{
                    height: "20px",
                    width: "20px",
                    objectFit: "contain",
                  }}
                  // data-tip="این ایستگاه در هیچ یک از گام‌های روال سفارش به کار نرفته است"
                  // data-delay-show="300"
                  // data-delay-hide="200"
                />
              </Tooltip>
            </div>
          )}

          <div
            className="qrObjectActionsContainer"
            style={{
              visibility: this.state.ActionsOpen ? "visible" : "hidden",
            }}
          >
            <div
              className="qrObjectActionButton"
              onClick={this.onEdit.bind(this)}
            >
              <img
                src={edit}
                alt=""
                style={{
                  width: "12px",
                  objectFit: "contain",
                  marginLeft: "6px",
                }}
              />
              <div>ویرایش</div>
            </div>

            <div
              className="qrObjectActionButton"
              onClick={this.onDisable.bind(this)}
            >
              <img
                src={this.props.isEnable ? disable : enable}
                alt=""
                style={{
                  width: "12px",
                  objectFit: "contain",
                  marginLeft: "6px",
                }}
              />
              <div>{this.props.isEnable ? "غیرفعال" : "فعال"}</div>
            </div>

            <div
              className="qrObjectActionButton"
              onClick={this.onDelete.bind(this)}
            >
              <img
                src={Delete}
                alt=""
                style={{
                  width: "12px",
                  objectFit: "contain",
                  marginLeft: "6px",
                }}
              />
              <div>حذف</div>
            </div>
          </div>
          <Modal
            show={this.state.ModalShow}
            animation={false}
            onHide={this.hideModal.bind(this)}
            centered
          >
            <div className="dialogBox">
              اطمینان از حذف "{this.props.title}"؟
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="خیر"
                    disable={this.state.deleteLoading}
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={this.hideModal.bind(this)}
                  />
                </div>
                <div style={{ minWidth: "5px" }} />
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="بله"
                    loading={this.state.deleteLoading}
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={this.itemDeleteConfirm.bind(this)}
                  />
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    } else {
      return (
        <div className="qrObjectContainer">
          <div className="qrObjectItem">
            <div
              style={{
                height: "45%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "space-between",
                width: "100%",
              }}
            >
              <div
                style={{
                  width: !this.props.editMode ? "49%" : "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={
                    this.props.editMode ? this.props.typeImg : this.props.qrImg
                  }
                  alt={this.props.qrImg}
                  style={{
                    height: "100%",
                    objectFit: "contain",
                    textAlign: "center",
                  }}
                />
              </div>
              {!this.props.editMode && (
                <div
                  style={{
                    width: "49%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <CustomButton
                      title="نمایش"
                      fontSize="12px"
                      minHeight="20px"
                      img={null}
                      backColor="var(--black1)"
                      onClick={this.showQRClick.bind(this)}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <CustomButton
                      title="کپی"
                      fontSize="12px"
                      minHeight="20px"
                      img={null}
                      backColor="var(--black1)"
                      onClick={this.copyURLClick.bind(this)}
                    />
                  </div>
                </div>
              )}
            </div>
            {/* <div className="qrObjectTitle">{this.props.title}</div> */}
            {/* <div className="qrObjectTitle"> */}
            <Form.Control
              className="inputStyleForm qrEditTextFont"
              placeholder="نام"
              type="text"
              name="nameValue"
              onChange={this.textHandleChange}
              value={this.state.nameValue}
              disabled={this.state.buttonDisabled}
              ref={this.NameInput}
              onKeyPress={this.handleKeyPress.bind(this)}
            />
            <div className="qrObjectCopyContainer">
              <div style={{ width: "49%" }}>
                <CustomButton
                  disable={this.state.saveLoading}
                  title=""
                  minHeight="30px"
                  img={Cancel}
                  backColor="var(--black1)"
                  onClick={this.cancelEditClick.bind(this)}
                />
              </div>
              <div style={{ width: "49%" }}>
                <CustomButton
                  loading={this.state.saveLoading}
                  title=""
                  minHeight="30px"
                  img={Tick}
                  backColor="var(--brown1)"
                  onClick={this.saveEditClick}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
